export enum ParamaterGroupType {
  FinancialAccountType = 'FinancialAccountType',
  CurrencyCode = 'CurrencyCode',
  AccountType = 'AccountType',
  UsingStatus = 'UsingStatus',
  ProcessType = 'ProcessType',
  InvoiceTypes = 'InvoiceTypes',
  InvoiceProfileTypes = 'InvoiceProfileTypes',
  AccountingTypes = 'AccountingTypes',
  TaxTypes = 'TaxTypes',
  ExemptionReasonTypes = 'ExemptionReasonTypes',
  QuantityTypes = 'QuantityTypes',
  DurationMeasureTypes = 'DurationMeasureTypes',
  OkcDescriptionTypes = 'OkcDescriptionTypes',
  DeliveryTermsTypes = 'DeliveryTermsTypes',
  PaymentMeansTypes = 'PaymentMeansTypes',
  InternetPaymentTypes = 'InternetPaymentTypes',
  WitholdingTaxTypes = 'WitholdingTaxTypes',
  TransportModeTypes = 'TransportModeTypes',
  OutgoingInvoiceStatusForUser = 'OutgoingInvoiceStatusForUser',
  EnvelopeStatus = 'EnvelopeStatus',
  OutgoingInvoiceStatus = 'OutgoingInvoiceStatus',
  PrintingStatus = 'PrintingStatus',
  ArchivingStatus = 'ArchivingStatus',
  PartyType = 'PartyType',
  IncomingInvoiceStatusForUser = 'IncomingInvoiceStatusForUser',
  OutgoingEnvelopeStatus = 'OutgoingEnvelopeStatus',
  EArchiveStatus = 'EArchiveStatus',
  EArchiveReportStatus = 'EArchiveReportStatus',
  EArchiveMailStatus = 'EArchiveMailStatus',
  XsltFileType = 'XsltFileType',
  DespatchAdviceTypes = 'DespatchAdviceTypes',
  DespatchAdviceProfileTypes = 'DespatchAdviceProfileTypes',
  DocumentType = 'DocumentType',
  DocumentDetailType = 'DocumentDetailType',
  OutgoingDespatchAdviceStatus = 'OutgoingDespatchAdviceStatus',
  SerialTypes = 'SerialTypes',
  OdemeSekli = 'OdemeSekli',
  PackagingTypeCode = 'PackagingTypeCode',
  DeliveryTerms = 'DeliveryTerms',
  EArchiveReportGibStatus = 'EArchiveReportGibStatus',
  ErpProcessStatus = 'ErpProcessStatus',
  ReceiptAdviceTypes = 'ReceiptAdviceTypes',
  ReceiptAdviceProfileTypes = 'ReceiptAdviceProfileTypes',
  OutgoingDespatchAdviceStatusForUser = 'OutgoingDespatchAdviceStatusForUser',
  DespatchProcessStatus = 'DespatchProcessStatus',
  IncomingDespatchAdviceStatusForUser = 'IncomingDespatchAdviceStatusForUser',
  IncomingDespatchAdviceStatus = 'IncomingDespatchAdviceStatus',
  QueueSignType = 'QueueSignType',
  SignState = 'SignState',
  MailState = 'MailState',
  InWorkFlowStatus = 'InWorkFlowStatus',
  OutgoingSmmStatus = 'OutgoingSmmStatus',
  ReportDocumentTypes = 'ReportDocumentTypes',
  HKSAdditionalItem = 'HKSAdditionalItem',
  HKSCostTypes = 'HKSCostTypes',
  OutgoingCreditNoteStatus = 'OutgoingCreditNoteStatus',
  IsDeletedStatusCodes = 'IsDeletedStatusCodes',
  ReadingStatus = 'ReadingStatus',
  IsCancelStatusCodes = 'IsCancelStatusCodes',
  DocumentObjectingType = "DocumentObjectingTypes",
  TicketReportType = "TicketReportStatus",
  OutgoingBillStatus = 'OutgoingBillStatus',
  PaymentType = 'PaymentType',
  ServiceType = 'ServiceType',
  SpendingTypes = 'SpendingTypes',
  ExpenseVoucherTypes = 'ExpenseVoucherTypes',
  OutgoingExpenseVoucherStatus = 'OutgoingExpenseVoucherStatus',
  DomesticLicensePlateScheme = 'DomesticLicensePlateScheme',
  ForeignLicensePlateScheme = 'ForeignLicensePlateScheme',
  DomesticTransportEquipmentScheme = 'DomesticTransportEquipmentScheme',
  ForeignTransportEquipmentScheme = 'ForeignTransportEquipmentScheme',
  TechnologySupportItemSchemes = 'TechnologySupportItemSchemes',
}
